import { Component } from '@angular/core';

@Component({
  selector: 'nw-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'medbook-message-widget';
}
